import React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box} from '@mui/material';
import { RenderParticipantName } from "./Elements";
import Trend from '../utils/Trend'; // Import the Trend component

export interface ProgressTableProps {
    data: any[]; // ParticipantProgress[];
    onParticipantClick: (participantId: number, name: string) => void;
}

const ProgressTable: React.FC<ProgressTableProps> = ({ data, onParticipantClick }) => {
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>Участник</TableCell>
                        <TableCell>∑ прогресс (%)</TableCell>
                        <TableCell>Макс. прогресс (%)</TableCell>
                        <TableCell>Записей</TableCell>
                        <TableCell>Последняя запись</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => (
                        <TableRow
                            key={row.participant_id}
                            sx={{
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }, // Highlight on hover for desktop
                            }}
                            onClick={() => onParticipantClick(row.participant_id, row.participant_name)} // Entire row clickable
                        >
                            <TableCell padding="checkbox" onClick={(e) => e.stopPropagation() /* Prevent row click */}>
                                <IconButton
                                    onClick={() => onParticipantClick(row.participant_id, row.participant_name)}
                                    size="small"
                                    aria-label="Подробнее"
                                >
                                    <Trend trend={row.progress_trend} />
                                </IconButton>
                            </TableCell>

                            {/* Participant Info */}
                            <TableCell>
                                {RenderParticipantName(
                                    row.participant_id,
                                    row.participant_name,
                                    row.profile_picture,
                                    true
                                )}
                            </TableCell>

                            {/* Progress Data */}
                            <TableCell>{row.total_progress.toFixed(0)}</TableCell>
                            <TableCell>{row.max_progress.toFixed(0)}</TableCell>
                            <TableCell>{row.total_entries}</TableCell>
                            <TableCell>{new Date(row.last_activity).toLocaleString()}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ProgressTable;
